export default __webpack_public_path__ + "files/thumbnail-212bccd798e04bc65b3a9bcb33f077cd.png";